var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPajama01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-174,.cls-173{fill:#fff;stroke:#000;stroke-miterlimit:10;}.cls-174{stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M146.78,98.55c-2.38,12.22-5.43,30.15-7.55,51.94-5,51.34-1.32,88.66,1.72,124.52,1.53,18.13-.24,41.35,1.54,67.74s3.18,55.64,4.82,90c5.66-.1,15.78.76,21.52.33,5.58-.43,14.2-.2,19.65-.95a641,641,0,0,1-2.74-99.06c2.78-51.47,8.73-95.8,18.71-131.94q.17-49.18.34-98.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M262.8,98.55c2.38,12.22,5.43,30.15,7.55,51.94,5,51.34,1.32,88.66-1.72,124.52-1.53,18.13.24,41.35-1.54,67.74s-.15,55.64-1.78,90c-5.67-.1-18.82.76-24.56.33-5.58-.43-11.76-1.9-17.21-2.66,2.94-28.43,2.24-61.33.3-97.35-2.78-51.47-8.73-95.8-18.71-131.94q-.16-49.18-.34-98.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M264.29,97.59c-3.52.94-8.65,2.19-14.92,3.27-16.61,2.88-30.2,2.71-41.34,2.52-1,0-2.09,0-3.25-.08s-2.24.06-3.24.08c-11.14.19-24.73.36-41.34-2.52-6.27-1.08-11.4-2.33-14.91-3.27Q147,91.31,148.69,85l27,4.21a122.48,122.48,0,0,0,15.67.76c4.55,0,9,.43,13.42.19,4.34.24,8.76-.23,13.25-.19a121.27,121.27,0,0,0,15.83-.76l27-4.21Q262.59,91.31,264.29,97.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPajama01);
export default __webpack_public_path__ + "static/media/PAJAMA-01.91c4b761c133e9e902e6f59a7f7fa6ed.svg";
export { ForwardRef as ReactComponent };